import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/codefile';

const initialState = fromJS({
  data: [],
  filter: {
    caseType: '',
    name: '',
    type: '',
  },
  summary: [],
  state: null,
  stateCreate: null,
  stateUpdate: null,
  stateDelete: null,
});

const CodefileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CODEFILES_FETCH_START:
    case actions.CODEFILE_SUMMARY_FETCH_START: {
      return state.set('state', fetchingState.FETCHING);
    }
    case actions.CODEFILES_FETCH_ERROR:
    case actions.CODEFILE_SUMMARY_FETCH_ERROR: {
      return state.set('state', fetchingState.ERROR);
    }
    case actions.CODEFILES_FETCH_SUCCESS: {
      return state
        .set('state', fetchingState.LOADED)
        .set('data', fromJS(_.get(action, 'data.results', [])));
    }
    case actions.CODEFILE_SUMMARY_FETCH_SUCCESS: {
      return state
        .set('state', fetchingState.LOADED)
        .set('summary', fromJS(_.get(action, 'data.results', [])));
    }
    case actions.CREATE_CODEFILE_START: {
      return state.set('stateCreate', fetchingState.FETCHING);
    }
    case actions.UPDATE_CODEFILE_START: {
      return state.set('stateUpdate', fetchingState.FETCHING);
    }
    case actions.DELETE_CODEFILE_START: {
      return state.set('stateDelete', fetchingState.FETCHING);
    }
    case actions.CREATE_CODEFILE_SUCCESS: {
      return state.set('stateCreate', fetchingState.LOADED);
    }
    case actions.UPDATE_CODEFILE_SUCCESS: {
      return state.set('stateUpdate', fetchingState.LOADED);
    }
    case actions.DELETE_CODEFILE_SUCCESS: {
      const { caseType, type, name, code } = action.payload;
      return state.set('stateDelete', fetchingState.LOADED).set(
        'data',
        fromJS(
          state
            .get('data')
            .toJS()
            .filter(codefile => {
              return !(
                codefile.caseType === caseType &&
                codefile.codeFileType === type &&
                codefile.codeFileName === name &&
                codefile.codeName === code
              );
            }),
        ),
      );
    }
    case actions.CREATE_CODEFILE_ERROR: {
      return state.set('stateCreate', fetchingState.ERROR);
    }
    case actions.UPDATE_CODEFILE_ERROR: {
      return state.set('stateUpdate', fetchingState.ERROR);
    }
    case actions.DELETE_CODEFILE_ERROR: {
      return state.set('stateDelete', fetchingState.ERROR);
    }
    case actions.UPDATE_CODEFILE_FILTER: {
      const prevState = state.get('filter').toJS();

      if (
        action.payload.filter === 'caseType' &&
        prevState.caseType !== action.payload.value
      ) {
        prevState.name = '';
        prevState.type = '';
      }

      if (
        action.payload.filter === 'type' &&
        prevState.type !== action.payload.value
      ) {
        prevState.name = '';
      }

      const nextState = {
        ...prevState,
        [action.payload.filter]: action.payload.value,
      };

      return state.set('filter', fromJS(nextState));
    }
    default: {
      return state;
    }
  }
};

export default CodefileReducer;
